<template>
  <div class="row d-flex justify-content-center align-items-center w-100">
    <div
      class="upload-card col-10 col-md-5 col-lg-4 rounded flex-col px-4 pb-2"
    >
      <div class="row d-flex justify-content-start page-header">
        <span class="col p-0"
          >Upload {{ formType === "mastering" ? "track" : "files" }}</span
        >
      </div>

      <div class="row">
        <div
          v-if="xhrErrorMainForm"
          class="alert alert-danger w-100 px-2 py-1"
          role="alert"
        >
          {{ xhrErrorMainForm }}
        </div>
      </div>

      <div class="row mt-3">
        <div class="col-12">
          <NewFileDropZone
            :type="addRefUrls ? 'track' : 'track'"
            :acceptFile="acceptedFiles"
            :multiple="allowMultipleFileUpload"
          />
        </div>
      </div>

      <div class="row">
        <input
          tabindex="0"
          class="mt-3 song-name"
          type="text"
          placeholder="Enter Song name..."
          v-model="songName"
          v-validate="'required'"
          name="songName"
        />
      </div>
      <div class="row inline-err">
        <span class="text-danger text-left" v-show="errors.has('songName')"
          >Song name required</span
        >
      </div>

      <div class="row">
        <input
          tabindex="0"
          class="mt-3 song-name"
          type="text"
          placeholder="Enter artist name..."
          v-model="artistName"
          v-validate="'required'"
          name="artistName"
        />
      </div>
      <div class="row inline-err">
        <span class="text-danger text-left" v-show="errors.has('artistName')"
          >Artist name required</span
        >
      </div>

      <div class="row">
        <input
          tabindex="0"
          class="mt-3 song-name"
          type="text"
          placeholder="Enter contact name..."
          v-model="producerName"
          v-validate="'required'"
          name="producerName"
        />
      </div>
      <div class="row inline-err">
        <span class="text-danger text-left" v-show="errors.has('producerName')"
          >Contact name required</span
        >
      </div>

      <div class="row">
        <input
          tabindex="0"
          class="mt-3 song-name"
          type="text"
          placeholder="Enter email..."
          v-model="email"
          v-validate="'required|email'"
          name="email"
        />
      </div>
      <div class="row inline-err">
        <span class="text-danger text-left" v-show="errors.has('email')"
          >Email is required</span
        >
      </div>

      <div class="row d-flex justify-content-end mt-4">
        <div class="col-12">
          <button
            :disabled="
              isSubmittingForm ||
                isSubmitButtonsDisabled ||
                isCheckingCredit ||
                fileUploading ||
                errors.items.length > 0
            "
            class="w-100 submit-btn py-2"
            @click="onSubmit"
            style="--width: var(
            '100%'
          )"
          >
            {{
              !isSubmittingForm && !isCheckingCredit
                ? "Submit"
                : submitButtonLoadingText
            }}
          </button>
        </div>
      </div>

      <div
        v-if="files.length > 0"
        class="row d-flex justify-content-between align-items-end added-tracks-label my-2"
      >
        <span class="col p-0">Added Tracks ({{ files.length }})</span>
        <div class="col-5 pr-3">
          <div class="row">
            <div class="col mx-0 px-0">
              <input
                tabindex="0"
                class="mt-3 song-name"
                type="text"
                placeholder="Search files"
                v-model="fileSearchKeyword"
              />
            </div>
            <div
              class="col-1 d-flex justify-content-center align-items-center"
              @click="clearSearch"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                fill="currentColor"
                class="bi bi-x-circle"
                viewBox="0 0 16 16"
              >
                <path
                  d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"
                />
                <path
                  d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <div
        class="added-tracks-container row"
        v-for="item in fileList"
        v-bind:key="item.id"
      >
        <div class="col-1">
          <img
            class="m-1 mr-3"
            src="../assets/folder.png"
            height="25"
            width="25"
            alt="folder"
          />
        </div>
        <div class="col">
          <p class="mb-0">{{ item.file.name }}</p>
          <div class="sub-text d-flex align-items-end">
            <p class="pr-4">{{ (item.file.size / 1024).toFixed(2) }} KB</p>
          </div>
        </div>
        <div class="col-1">
          <img
            class="m-1 remove-file-btn"
            src="../assets/trash.png"
            height="20"
            width="20"
            alt="status"
            @click="removeFile(item.file.name)"
          />
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div
      class="modal fade"
      id="loadingProgressModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="loadingProgressModal"
      aria-hidden="false"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row">
              <div class="col-auto pr-0 d-flex">
                <h2 class="category-title">
                  Files uploading
                </h2>
              </div>
            </div>
            <div>
              <h2>{{ songName }}</h2>
            </div>
            <div class="confirm-modal-message">
              <span v-if="fileUploading">
                Uploading <b> {{ fileUploading }} </b>
              </span>
            </div>

            <div v-if="isSubmittingForm" class="row px-3">
              <div class="col-12">
                <div class="progress">
                  <div
                    class="progress-done"
                    :style="{
                      width: loadingProgress
                    }"
                  >
                    <span class="ml-4">
                      {{ loadingProgress }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NewFileDropZone from "../components/NewFileDropZone.vue";
import { mapState } from "vuex";
import { stringHasSpecialCharacters } from "@/utils/string-utils";
import axios from "axios";
import { createNewProject } from "../services/projects";
import { createCustomTrackOrder } from "../services/track";
import { getS3SignedNonAuthed } from "../services/s3";

const categoryTitleKeyPair = {
  stereo: "Full Stem Mix",
  track: "2 Track Mix",
  atmos: "Atmos Mix",
  mastering: "Master"
};

export default {
  components: {
    NewFileDropZone
  },
  mounted() {
    this.$route.params.cat ? (localStorage.cat = this.$route.params.cat) : "";
    this.$store.dispatch("apiEvents/fetchActiveGroups", {
      isSimple: this.isSimple,
      trackCategory: localStorage.cat
    });
  },
  data() {
    return {
      catg: this.$route.params.cat ? this.$route.params.cat : localStorage.cat,
      formType: this.$route.params.cat ? this.$route.params.cat : "stereo",
      files: [],
      refFiles: [],
      songName: null,
      artistName: null,
      email: null,
      producerName: null,
      fileSearchKeyword: null,
      trackUrls: [],
      refUrls: [],
      selectedProject: "",
      addRefUrls: false,
      progressValue: 0,
      isSubmittingForm: false,
      isCheckingCredit: false,
      fileUploading: null,
      newProjectName: null,
      assignProject: false,
      submittingNewProject: false,
      xhrErrorMainForm: null,
      xhrErrorCreateProject: null
    };
  },
  watch: {
    "$store.state.trackData.currentDataList": function() {
      this.files = this.$store.state.trackData.currentDataList;
    },
    "$store.state.trackData.currentRefList": function() {
      this.refFiles = this.$store.state.trackData.currentRefList;
    },
    formType: function() {
      if (this.formType === "mastering") {
        this.$store.dispatch("trackData/clearRefFile");
        this.addRefUrls = false;
      }
    }
  },
  computed: {
    ...mapState(["apiEvents"], ["trackData"]),
    submitButtonLoadingText() {
      if (this.isCheckingCredit) {
        return "Checking credit...";
      }

      if (this.fileUploading && this.fileUploading === "track") {
        return "Uploading track files...";
      }

      if (this.fileUploading && this.fileUploading !== "track")
        return "Uploading reference files";
      return null;
    },
    isSimple() {
      // return this.$store.state.trackData.trackStyle == "Simple" ? true : false;
      return false;
    },
    requiredFiles() {
      let f = [];

      if (this.$store.state.trackData.currentRefList.length === 0) {
        f.push("Add atleast 1 reference track");
      }

      if (this.$store.state.trackData.currentDataList.length === 0) {
        f.push("Add atleast 1 track");
      }
      return f;
    },
    isSubmitButtonsDisabled() {
      if (this.formType === "mastering") {
        return (
          (!this.songName && this.songName !== "") ||
          !this.$store.state.trackData.currentDataList.length === 0
        );
      } else {
        return (
          this.$store.state.trackData.currentDataList.length === 0 ||
          (!this.songName && this.songName !== "") ||
          (!this.artistName && this.artistName !== "") ||
          (!this.producerName && this.producerName !== "") ||
          (!this.email && this.email !== "")
        );
      }
    },
    loadingProgress() {
      return `${this.progressValue}%`;
    },
    formSwitcherClass() {
      switch (this.formType) {
        case "stereo":
          return {
            first: true
          };

        case "track":
          return {
            second: true
          };

        case "atmos":
          return {
            third: true
          };

        case "mastering":
          return {
            fourth: true
          };
      }

      return null;
    },
    allowMultipleFileUpload() {
      return this.formType !== "mastering";
    },
    acceptedFiles() {
      return "audio/*, audio/x-mp3, audio/x-m4a, audio/x-wav, application/zip";
    },
    credits() {
      switch (this.formType) {
        case "stereo":
          return `${this.$store.state.apiEvents.remainingStereoMix} Full stereo mixes remaining`;

        case "track":
          return `${this.$store.state.apiEvents.remainingTracks} 2 track mixes remaining`;

        case "atmos":
          return `${this.$store.state.apiEvents.remainingAtmosMix} Atmos mixes remaining`;

        case "mastering":
          return `${this.$store.state.apiEvents.remainingMasteringMix} Master remaining`;
        default:
          return "0 Remaining";
      }
    },
    fileList() {
      if (this.fileSearchKeyword) {
        return this.files.filter(file => {
          const regExp = new RegExp(this.fileSearchKeyword, "i");
          return regExp.test(file.file.name);
        });
      }
      return this.files;
    }
  },
  methods: {
    getCategoryTitle(category) {
      return categoryTitleKeyPair[category];
    },
    onNameChange(e) {
      this.songName = e.target.value;
      if (stringHasSpecialCharacters(this.songName)) {
        this.nameError = 1;
        this.disabledbtn = 1;
        this.nameclass = "inp-danger";
        this.error = 1;
      } else {
        this.nameError = 0;
        this.disabledbtn = 0;
        this.nameclass = "n-input";
      }
    },
    clearSearch() {
      this.fileSearchKeyword = null;
    },
    switchForm(formType) {
      this.$route.params.cat = formType;
      this.formType = formType;
    },
    removeFile(name, type) {
      if (type === "ref") {
        this.$store.dispatch("trackData/removeRefFile", { fileName: name });
      } else {
        this.$store.dispatch("trackData/removeTrackFile", { fileName: name });
      }
    },
    async onUpload() {
      if (
        this.songName !== "" &&
        this.$store.state.trackData.currentDataList.length > 0
      ) {
        this.disabledbtn = 1;
        this.trackStatus = 0;
        await this.uploadS3Helper(this.songName.toString());
      } else {
        if (this.songName === "") {
          this.nameclass = "inp-danger";
          this.error = 1;
          this.disabledbtn = 0;
        }
      }
    },
    async onSubmit() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.uploadS3Helper(this.songName.toString());
        }
      });
    },
    async uploadS3Helper(trackname) {
      const trackList = this.$store.state.trackData.currentDataList;

      $("#loadingProgressModal").modal("show");

      for (let i = 0; i < trackList.length; i++) {
        const filePathObj = await this.fileKeyPathGenerator(
          trackList[i].file,
          trackname,
          "Track"
        );
        try {
          const res = await this.generateS3Request(
            trackList[i].file,
            filePathObj.key
          );
          this.fileUploading = "track";
          await this.uploadOnUrl(res.data.signedRequest, trackList[i].file);

          this.trackUrls.push({
            stemUrl: `https://s3.amazonaws.com/quickmix/${filePathObj.key}`,
            stemGroup: "",
            stemName: trackList[i].file.name
          });
        } catch (error) {
          console.log(error);
          // this.$refs["progress-modal"].hide();
          await this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!"
          });

          this.uploadError = 1;
          throw "exit";
        }
      }

      if (!this.uploadError) {
        try {
          $("#loadingProgressModal").modal("hide");
          await this.createTrackHelper();
        } catch (error) {
          console.log(error);
          throw "exit";
        }
      }
    },
    async uploadOnUrl(url, file) {
      this.timeStamp = Date.now();
      this.prevProgress = 0;
      this.progressValue = 0;
      this.isSubmittingForm = true;
      this.xhrErrorMainForm = null;
      this.fileUploading = file.name;
      try {
        await axios.put(url, file, {
          headers: {
            "Content-Disposition": "attachment",
            "Content-Type": file.type
          },
          maxContentLength: Infinity,
          onUploadProgress: progress => {
            let percentCompleted = Math.round(
              (progress.loaded * 100) / progress.total
            );
            let time = Date.now() - this.timeStamp;
            let percent = (percentCompleted - this.prevProgress) / 100;
            let chunk = percent * file.size;
            let speed = (chunk / 1024 / 1024 / (time / 1000)).toFixed(2);

            this.timeStamp = Date.now();
            this.prevProgress = percentCompleted;

            this.speed = speed;

            this.progressValue = percentCompleted;
          }
        });
      } catch (error) {
        if (error.response && error.response.data) {
          this.xhrErrorMainForm =
            error.response.data.message ||
            "Unexpected error occured. Contact support@getmxd.com";
        } else {
          this.xhrErrorMainForm =
            "Unexpected error occured. Contact support@getmxd.com";
        }

        throw this.xhrErrorMainForm;
      } finally {
        this.isSubmittingForm = false;
      }
    },
    formattedDate() {
      let d = new Date(),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },

    async fileKeyPathGenerator(file, trackName, type) {
      const date = this.formattedDate();
      const fileExt = file.name.split(".").pop();
      const path =
        localStorage.getItem("mxdUserName") +
        `_${type}_` +
        "1" +
        "_" +
        file.name
          .replace("adlib", "adlibs")
          .split("#")
          .join("_")
          .split("&")
          .join("_")
          .split("?")
          .join("_")
          .split(".")
          .slice(0, file.name.split(".").length - 1)
          .toString()
          .split(" ")
          .join("-") +
        "." +
        fileExt;

      const key =
        localStorage.getItem("mxdUserName") +
        `${type === "Track" ? "" : "/References"}/` +
        date +
        "/" +
        trackName.split(" ").join("-") +
        "/" +
        path;
      return {
        key: key,
        path: path
      };
    },
    async generateS3Request(file, key) {
      let url;
      try {
        url = await getS3SignedNonAuthed(file.name, file.type, key);
      } catch (error) {
        console.log("error", error);
        throw error;
      }
      return url;
    },
    async createTrackHelper() {
      const customOrderObj = {
        trackName: this.songName,
        producerName: this.producerName,
        artistName: this.artistName,
        email: this.email,
        trackFiles: this.trackUrls,
        projectId:
          this.selectedProject && this.selectedProject != ""
            ? this.$store.state.apiEvents.userProjects.find(item => {
                return item.name === this.selectedProject;
              }).id
            : 0
      };

      const customOrder = await createCustomTrackOrder(customOrderObj);
      this.responseFunc(customOrder);
    },
    async responseFunc(res) {
      if (res.data.success) {
        await this.$swal.fire({
          position: "top-end",
          icon: "success",
          title: "Track Uploaded",
          showConfirmButton: false,
          timer: 1500
        });
        if (res.data.trackID) {
          // push to a thank you page
          this.$router.push("../custom-track-success");
        } else {
          this.$router.push("../dashboard");
        }
      } else {
        await this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!"
        });
      }
    },
    toggleRefUrls() {
      this.addRefUrls = !this.addRefUrls;
    },
    async createProject() {
      if (this.newProjectName !== "") {
        this.xhrErrorCreateProject = null;
        this.submittingNewProject = true;
        try {
          const userID = localStorage.getItem("userId");
          const f = await createNewProject(userID, this.newProjectName);
          // fetch new
          this.$store.dispatch("apiEvents/fetchProjectsByUserId", {
            id: userID
          });
          this.selectedProject = this.newProjectName;
          this.newProjectName = "";
          this.assignProject = false;
        } catch (error) {
          if (error.response && error.response.data) {
            this.xhrErrorCreateProject =
              error.response.data.message ||
              "Unexpected error occured. Contact support@getmxd.com";
          } else {
            this.xhrErrorCreateProject =
              "Unexpected error occured. Contact support@getmxd.com";
          }
        } finally {
          this.submittingNewProject = true;
        }
      } else {
        this.xhrErrorMainForm = "Song name required.";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
#loadingProgressModal {
  color: black !important;

  .category-title {
    font-family: "Poppins", sans-serif !important;
    font-weight: bold;
  }

  .cancel-btn,
  .confirm-btn {
    background: none;
    border: none;
    font-family: "Poppins", sans-serif !important;
    font-size: 24px;
    font-weight: bold;
  }

  .confirm-btn {
    background-color: #7dfcd684;
    border-radius: 20px;
  }
}

.page-header {
  font-family: "Poppins", sans-serif !important;
  font-size: 32px;
  font-weight: bold;
  text-transform: uppercase;
}

.upload-card {
  background-color: #1a1c22;
  font-family: "Poppins", sans-serif !important;
}

.form-switcher {
  position: relative;
  background-color: #63697b;
  border-radius: 1rem;

  .col {
    z-index: 1;
    display: flex;
    font-family: "Poppins", sans-serif !important;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &:nth-child(1) {
      font-size: 13px;
    }
  }
}

.form-switcher::after {
  content: "";
  position: absolute;
  width: 25%;
  bottom: 0;
  transition: left cubic-bezier(0.88, -0.35, 0.565, 1.35) 0.4s,
    border-radius 0.4s ease;
  box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.1);
  background-color: #7dfcd684;
  height: 100%;
}

.form-switcher.first::after {
  left: 0;
  border-radius: 1rem 0rem 0rem 1rem;
}

.form-switcher.second::after {
  left: 25%;
  border-radius: 0px;
}

.form-switcher.third::after {
  left: 50%;
  border-radius: 0px;
}

.form-switcher.fourth::after {
  left: 75%;
  border-radius: 0rem 1rem 1rem 0rem;
}

.form-switcher .disabled {
  color: gray;
}

.song-name {
  font-family: "Poppins", sans-serif !important;
  background: none;
  outline: none;
  border: none;
  color: white;
  border-bottom: 1px solid grey;
  width: 100%;
}

.submit-btn {
  background-color: #7dfcd684;
  font-family: "Poppins", sans-serif !important;
  color: white;
  border-radius: 1rem;
  position: relative;
  border: none;

  &:disabled {
    color: black;
    background-color: #3b5c5284;
  }

  &:after {
    content: "";
    height: 100%;
    width: var(--width);
    top: 0;
    left: 0;
    border-radius: 1rem;
    background-color: red;
    display: flex;
    position: absolute;
  }
}

.add-reference {
  button {
    border: none;
    font-family: "Poppins", sans-serif !important;
    color: white;
    background-color: transparent;
    font-size: 12px;
  }
}

.added-tracks-label {
  span {
    font-family: "Poppins", sans-serif !important;
    font-weight: 600;
  }
}

.progress {
  background-color: #d8d8d8;
  border-radius: 20px;
  position: relative;
  margin: 15px 0;
  height: 25px;
  width: 100%;
}

.progress-done {
  font-family: "Poppins", sans-serif !important;
  background: linear-gradient(to left, #417d6b94, #7dfcd636);
  box-shadow: 0 3px 3px -5px #7dfcd684, 0 2px 5px #f2709c;
  border-radius: 10px;
  color: black;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  opacity: 1;
  transition: 0.1s ease;
}

.custom-select {
  background-color: transparent;
  color: white;

  option {
    background: transparent;
    color: black;
  }
}

.new-project-btn {
  cursor: pointer;
  text-decoration: underline;
}

.create-project {
  input {
    color: white;
  }

  button {
    color: white;
  }
}

.create-project-error {
  color: rgb(226, 132, 132);
}

.select-project-header {
  font-family: "Poppins", sans-serif !important;
  font-weight: bold;
}

.remove-file-btn {
  cursor: pointer;
}
</style>
